var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(`background-color:${_vm.bg}`),attrs:{"id":"ultra-frame"}},[_c('div',{attrs:{"id":"ultra-container"}},[_c('WorkPackageHead',{attrs:{"head":_vm.head,"background_color":_vm.bg,"foreground_color":_vm.fg},on:{"selectStatus":function($event){return _vm.selectStatus($event)}}}),_c('CollapsableCategory',{attrs:{"value":"Description","color":_vm.fg},scopedSlots:_vm._u([{key:"content",fn:function({ is_collapsed, }){return [_c('TransitionAccordion',[(!is_collapsed)?_c('div',[_c('TText',{attrs:{"text":_vm.head.name,"small":"","font_weight":500,"color":_vm.fg}}),_c('TText',{attrs:{"text":_vm.head.area,"small":"","font_weight":500,"color":_vm.fg}}),_c('TText',{attrs:{"text":_vm.description,"small":"","color":_vm.fg}})],1):_vm._e()])]}}])}),_c('CollapsableCategory',{attrs:{"value":"Steps","color":_vm.fg},scopedSlots:_vm._u([{key:"content",fn:function({ is_collapsed }){return [_c('WorkPackageStepCategoryList',{attrs:{"items":[
            {
              id: 0,
              step_type: 'LOGISTIC',
              progress: { done_count: 10, task_count: 12 },
            },
            {
              id: 1,
              step_type: 'DESIGN',
              progress: { done_count: 4, task_count: 6 },
            },
            {
              id: 2,
              step_type: 'WORK',
              progress: { done_count: 1, task_count: 10 },
            },
            {
              id: 3,
              step_type: 'QUALITY',
              progress: { done_count: 8, task_count: 10 },
            },
            {
              id: 4,
              step_type: 'DEFECT',
              progress: { done_count: 0, task_count: 3 },
            },
            {
              id: 5,
              step_type: 'HANDOVER',
              progress: { done_count: 2, task_count: 2 },
            },
            {
              id: 6,
              step_type: 'MATERIAL',
              progress: { done_count: 1, task_count: 2 },
            },
            {
              id: 7,
              step_type: 'MACHINE',
              progress: { done_count: 1, task_count: 3 },
            },
            {
              id: 8,
              step_type: 'SENSOR',
              progress: { done_count: 3, task_count: 4 },
            },
            {
              id: 9,
              step_type: 'ROBOTIC',
              progress: { done_count: 0, task_count: 0 },
            },
          ],"has_lines":true,"is_collapsed":is_collapsed,"background_color":_vm.bg,"foreground_color":_vm.fg,"items_per_row":5}})]}}])}),_c('CollapsableCategory',{attrs:{"value":"Time Record","color":_vm.fg},scopedSlots:_vm._u([{key:"content",fn:function({ is_collapsed }){return [_c('TimeRecord',{attrs:{"equations":[
            {
              description: 'Min/Max',
              /* label (string), label_size (number), icon (string), text (string), operator (string) */
              elements: [
                { label: 'Time effort', icon: 'mdi-speedometer', text: '35', operator: '', is_disabled: true },
                { icon: '', text: '', operator: '/'},
                { label: 'Manpower', icon: 'mdi-human', text: '1,00', operator: '', is_disabled: true },
                { icon: '', text: '', operator: '='},
                { label: 'Duration', icon: 'mdi-timer-outline', text: '35', operator: '', is_disabled: true },
              ],
            },
            {
              description: 'Plan',
              /* label (string), label_size (number), icon (string), text (string), operator (string) */
              elements: [
                { label: 'Time effort', icon: 'mdi-speedometer', text: '35', operator: '', is_disabled: true },
                { icon: '', text: '', operator: '/'},
                { label: 'Manpower', icon: 'mdi-human', text: '1,00', operator: '', is_disabled: true },
                { icon: '', text: '', operator: '='},
                { label: 'Duration', icon: 'mdi-timer-outline', text: '35', operator: '', is_disabled: true },
              ],
            },
            {
              description: 'On Site',
              /* label (string), label_size (number), icon (string), text (string), operator (string) */
              elements: [
                { label: 'Time Effort', icon: 'mdi-speedometer', text: '', operator: '', is_disabled: true },
                { icon: '', text: '', operator: '='},
                { label: 'Manpower', icon: 'mdi-human', text: '', operator: '', is_disabled: false },
                { icon: '', text: '', operator: 'x'},
                { label: 'Duration', icon: 'mdi-timer-outline', text: '', operator: '', is_disabled: false },
              ],
            }
          ],"time_squares":[
            { description: 'Mo', is_badge: true, },
            { description: 'Tu', is_disabled: true, },
            { description: 'We', is_badge: true, },
            { description: 'Th', is_disabled: true, },
            { description: 'Fr', },
            { description: 'Sa', is_disabled: true, },
            { description: 'Su', is_disabled: true, },
            { is_invisible: true, },
            { is_invisible: true, },
            { description: '⌀', },
          ],"is_collapsed":is_collapsed,"collapsed_equations":[
            {
              elements: [{ label: 'Manpower', icon: 'mdi-human', text: '1,00', operator: '', is_disabled: true }],
            },
            {
              elements: [{ label: 'Plan', icon: 'mdi-timer-outline', text: '35', operator: '', is_disabled: true }],
            },
            {
              elements: [{ label: 'On Site', icon: 'mdi-speedometer', text: '35', operator: '', is_disabled: true }],
            },
          ],"background_color":_vm.bg,"foreground_color":_vm.fg}})]}}])}),_c('CollapsableCategory',{attrs:{"value":"Features","color":_vm.fg,"is_disabled":true}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }